<template>
    <form ref="form" v-on="formEvents">
        <div v-if="loading && formVisibility"
             class="text-center text-primary text-20 line-height-07 mb-5 mt-5 d-flex justify-content-center align-items-center">
            <div class="loader"></div>
        </div>

        <div @click="showForm" class="form-group">
            <label>Beneficiary Phone Number</label>
            <phone-input v-model="form.receiver" :countries="['ZW']" @keyup="showForm"></phone-input>
            <div v-text="form.errors.get('receiver')" class="text-danger"/>
        </div>

        <transition name="slide-in-top">
            <div >
                <div class="form-group">
                    <label>Pay with</label>
                    <select v-model="form.payment"
                            :class="[ 'custom-select' , form.errors.get('payment') ? 'is-invalid' : '' ]">
                        <option value="ecocash">EcoCash ZWG</option>
                        <option value="ecocash-usd">EcoCash USD</option>
                        <option value="stripe">International Card</option>
                    </select>
                    <div v-text="form.errors.get('payment')" class="invalid-feedback"/>
                </div>

                <div v-if="!loading" class="form-group">
                    <label>Category</label>
                    <select required v-model="form.category"
                            :class="[ 'custom-select' , form.errors.get('category') ? 'is-invalid' : '' ]">
                        <option value="">Choose Category</option>
                        <option v-for="cat in categories" :value="cat">{{ cat.replace('_', ' ') }}</option>
                    </select>
                    <div v-text="form.errors.get('category')" class="invalid-feedback"/>
                </div>

                <div v-if="!loading" class="form-group">
                    <label>Bundle</label>
                    <select required v-model="form.bundle"
                            :class="[ 'custom-select' , form.errors.get('bundle') ? 'is-invalid' : '' ]">
                        <option value="">Choose Bundle</option>
                        <optgroup :key="key" :label="key.replace('_', ' ')" v-for="key in Object.keys(filteredBundles)">
                            <option :key="b.id" v-for="b in filteredBundles[key]" :value="b.id">
                                {{ methods[form.payment] }}
                                {{ b.ratedPrice }} - {{ b.description }}
                            </option>
                        </optgroup>
                    </select>
                    <div v-text="form.errors.get('bundle')" class="invalid-feedback"/>
                    <div class="small text-black-50">
                        Looking for
                        <a href="#" @click.prevent="switchCurrency({name:'USD'})">Smart USD Bundles</a>
                        instead?
                    </div>
                </div>

                <div v-if="form.payment === 'ecocash' || form.payment === 'ecocash-usd'" class="form-group">
                    <label>EcoCash Phone Number</label>
                    <phone-input key="1" v-model="form.phone" :countries="['ZW']"></phone-input>
                    <div v-text="form.errors.get('phone')" class="text-danger"/>
                    <small class="text-black-50">* Also used for notifications</small>
                </div>

                <div v-else class="form-group">
                    <label>Email</label>
                    <input type="email" v-model="form.email" value="email"
                           required
                           :class="[ 'form-control' , form.errors.get('email') ? 'is-invalid' : '' ]"
                           placeholder="Email">
                    <div v-text="form.errors.get('email')" class="invalid-feedback"/>
                </div>

                <div class="form-group">
                    <label>Amount <br>
                        {{ methods[form.payment] === 'USD' ? `[ This transaction qualifies for a promotional ${actual_discount}% discount]` : '' }}
                    </label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                {{ methods[form.payment] }}
                            </span>
                        </div>
                        <input type="number" disabled :value="discounted"
                               :class="[ 'form-control' , form.errors.get('amount') ? 'is-invalid' : '' ]"
                               placeholder="Amount">
                        <div v-if="methods[form.payment] === 'USD' " class="input-group-prepend bg-success text-white">
                            <span class="input-group-text bg-success text-white">
                                Discounted Price
                            </span>
                        </div>
                        <div v-text="form.errors.get('amount')" class="invalid-feedback"/>
                    </div>
                </div>
                <div class="form-group d-flex align-items-center">
                    <input type="checkbox" class="mr-2" id="checkterms" v-model="termsAccepted">
                    <label class="mb-0" for="checkterms">I accept the <a target="_blank" href="/terms">Terms & Conditions</a></label>
                </div>
            </div>
        </transition>

        <div class="form-group">
            <button @click="formVisibility ? submit($event) : (formVisibility = true)"
                    type="button"
                    v-on="buttonValidity"
                    :class="{'btn-loading': form.loading || loading, ...buttonValidity.class}">
                Buy Bundle
            </button>
        </div>
    </form>
</template>

<script>
import Form from "../../../core/forms/form";
import {validity} from "../../../core/forms/validity";
import PhoneInput from "../../custom/phone-input";
import {appDataMixin} from "../../../core/data/global";

function groupByKey(array, key) {
    return array
        .reduce((hash, obj) => {
            if (obj[key] === undefined) return hash;
            return Object.assign(hash, {[obj[key]]: (hash[obj[key]] || []).concat(obj)})
        }, {})
}

export default {
    name: "dashboard",
    components: {PhoneInput},
    mixins: [validity, appDataMixin],
    data: function () {
        return {
            loading: true,
            fields: [
                'receiver',
                'phone',
                'email',
            ],
            methods: {
                'ecocash': 'ZWG',
                'stripe': 'USD',
                'ecocash-usd': 'USD',
            },
            bundles: [],
            categories: [],
            rate: 1,
            discount: 1,
            form: new Form({
                'receiver': '',
                'payment': 'ecocash',
                'category': '',
                'bundle': '',
                'phone': '',
                'amount': '',
                'email': '',
                'network': 'econet',
            })
        };
    },
    computed: {
        actual_discount() {
            return Math.floor((((this.discount) / (1 + this.discount)) * 100));
        },
        price: function () {
            return this.calculateUsdPrice(this.selected_bundle_price);
        },
        discounted: function () {
            return this.calculateDiscountedUsdPrice(this.selected_bundle_price);
        },
        selected_bundle_price() {
            return this.form.bundle !== '' && !this.loading ? this.bundles.find(e => e.id === this.form.bundle).price : 0
        },
        filteredBundles() {
            const bundles = (this.form.category === '' && !this.loading ? this.bundles : this.bundles.filter(e => e.category === this.form.category)).map(
                e => ({
                    ...e,
                    ratedPrice: this.methods[this.form.payment] === "ZWG" ? e.price : this.calculateUsdPrice(e.price)
                })
            );

            return groupByKey(bundles, 'category')
        }
    },
    methods: {
        calculateUsdPrice(price) {
            price = parseFloat(price);
            return this.methods[this.form.payment] === "ZWG"
                ? price :
                // ((price / this.rate) * (1 - ((this.discount / 100)))).toFixed(2);
                ((price / this.rate)).toFixed(2);
        },
        calculateDiscountedUsdPrice(price) {
            price = parseFloat(price);
            return this.methods[this.form.payment] === "ZWG"
                ? price :
                ((price / this.rate) *
                    ((1 - this.actual_discount / 100))
                ).toFixed(2);
        },
        fetchBundles() {
            this.loading = true;
            window.axios.get(`${window.location.origin}/bundles/prepare`).then((response) => {
                this.bundles = response.data.body.bundles;
                this.categories = response.data.body.categories;
                this.rate = response.data.body.rate;
                this.discount = response.data.body.discount / 100;
                this.getFromLocalStorage();
            }).finally(() => {
                this.loading = false;
            });
        },
        saveToLocalStorage() {
            for (let i = 0; i < this.fields.length; i++) {
                localStorage.setItem(this.fields[i], this.form[this.fields[i]]);
            }
        },
        getFromLocalStorage() {
            for (let i = 0; i < this.fields.length; i++) {
                let value = localStorage.getItem(this.fields[i]);
                if (value != null && value !== "" && value !== "null") {
                    this.form[this.fields[i]] = value;
                }
            }
        },
        submit(event) {
            // Save to Local Storage
            if (this.valid) {
                event.preventDefault()

                this.saveToLocalStorage();
                this.form.submit('/bills/bundles/init').then((response) => {

                    // Redirect based on payment type
                    if (response.data.success) {
                        if (response.data.body.payment.payment === "ecocash" || response.data.body.payment.payment === "ecocash-usd") {
                            this.$router.push(`/bundles/ecocash?id=${response.data.body.payment.ref}`);
                        }

                        if (response.data.body.payment.payment === "stripe") {
                            window.location.href = response.data.body.payment.url;
                        }

                    } else {

                    }
                });
            }
        }
    },
    mounted() {
        this.scrollToTop();
        this.fetchBundles();
        this.getFromLocalStorage();
    }
}
</script>
